import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { API_BASE_URL, getAuthHeader } from '../../../services/api';

export const createBooking = createAsyncThunk('bookings/create', async (bookingData, thunkAPI) => {
  try {
    const response = await axios.post(`${API_BASE_URL}/bookings`, bookingData, { headers: getAuthHeader() });
    return response.data;
  } catch (error) {
    console.error('Error response:', error.response?.data); // log the response data
    return thunkAPI.rejectWithValue(error.response?.data?.message || error.message);
  }
});

export const fetchUserBookings = createAsyncThunk('bookings/fetchUser', async (_, thunkAPI) => {
  try {
    const response = await axios.get(`${API_BASE_URL}/bookings`, { headers: getAuthHeader() });
    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response?.data?.msg || error.message);
  }
});

const initialState = { bookings: [], currentBooking: null, isLoading: false, error: null };
const bookingSlice = createSlice({
  name: 'bookings',
  initialState,
  reducers: { clearCurrentBooking: (state) => { state.currentBooking = null; } },
  extraReducers: (builder) => {
    builder
      .addCase(createBooking.pending, (state) => { state.isLoading = true; })
      .addCase(createBooking.fulfilled, (state, action) => { state.isLoading = false; state.currentBooking = action.payload; state.bookings.unshift(action.payload); })
      .addCase(createBooking.rejected, (state, action) => { state.isLoading = false; state.error = action.payload; })
      .addCase(fetchUserBookings.pending, (state) => { state.isLoading = true; })
      .addCase(fetchUserBookings.fulfilled, (state, action) => { state.isLoading = false; state.bookings = action.payload; })
      .addCase(fetchUserBookings.rejected, (state, action) => { state.isLoading = false; state.error = action.payload; });
  },
});
export const { clearCurrentBooking } = bookingSlice.actions;
export default bookingSlice.reducer;